import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

function Register() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [displayName, setName] = useState('');
    const [error, setError] = useState('');
  
    const auth = getAuth();
  
    const handleRegister = async (e) => {
      e.preventDefault();
  
      try {
        await createUserWithEmailAndPassword(auth, email, password);
        // If registration is successful, you can redirect to the login page or update the UI as needed.
      } catch (error) {
        setError(error.message);
      }
    };
  
    return (
      <div>
        <h2>Register</h2>
        <form onSubmit={handleRegister}>
            {/* displayName */}
            <div>
            <label>Name:</label>
            <input
                type="text"
                value={displayName}
                onChange={(e) => setName(e.target.value)}
            />
            </div>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit">Register</button>
        </form>
        {error && <p>{error}</p>}
      </div>
    );
  }
  
  export default Register;
  